<template>
  <div class="page-preferences">
    <h1 class="title">Organization Preferences</h1>

    <div v-if="loading" class="has-text-centered mt-6">
      <span class="loader is-loading is-large"></span>
    </div>

    <div v-else class="box">
      <!-- === PDF TEMPLATE SELECTION === -->
      <div class="field">
        <label class="label">Default PDF template</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="form.select_pdf">
              <option value="clean">Minimal Clean</option>
              <option value="modern">Modern Business</option>
              <option value="creative">Creative Green</option>
            </select>
          </div>
        </div>
        <p class="help">
          This defines the default layout used when exporting documents.
        </p>
      </div>

      <!-- === COMMUNICATION TYPE === -->
      <div class="field">
        <label class="label">Default communication type</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="form.default_communication_type">
              <option value="free">Free</option>
              <option value="structured">Structured</option>
            </select>
          </div>
        </div>
      </div>

      <!-- === SAVE BUTTON === -->
      <div class="buttons mt-4">
        <button
          class="button is-success"
          @click="savePreferences"
          :disabled="saving"
        >
          {{ saving ? 'Saving…' : 'Save Preferences' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';
import { toast } from 'bulma-toast';

export default {
  name: 'PreferencesView',
  data() {
    return {
      loading: true,
      saving: false,
      form: {
        id: null,
        select_pdf: 'clean',
        default_communication_type: 'free',
        default_vat: null,
      },
    };
  },
  async mounted() {
    await this.fetchPreferences();
  },
  methods: {
    async fetchPreferences() {
      try {
        const resp = await api.get(
          '/preferences/organization-preferences/current/'
        );
        this.form = resp.data;
      } catch (err) {
        console.error(err);
        toast({ message: 'Failed to load preferences.', type: 'is-danger' });
      } finally {
        this.loading = false;
      }
    },
    async savePreferences() {
      try {
        this.saving = true;

        await api.patch('/preferences/organization-preferences/current/', {
          select_pdf: this.form.select_pdf,
          default_communication_type: this.form.default_communication_type,
        });

        toast({
          message: 'Preferences saved successfully.',
          type: 'is-success',
          position: 'bottom-right',
        });
      } catch (err) {
        console.error(err);
        toast({
          message: 'Failed to save preferences.',
          type: 'is-danger',
          position: 'bottom-right',
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.page-preferences {
  max-width: 640px;
  margin: 0 auto;
}
.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #00d1b2;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
